import { ValidationMessages } from '@app/core/validation-messages';
import { ErrorType } from '@shared/models/error-type';

export const ATTACHMENT_DOWNLOAD_ERRORS: Record<
  string,
  { message: string; type: ErrorType }
> = {
  inspection_not_found: {
    message: ValidationMessages.InspectionNotFound,
    type: 'error'
  },
  no_attachments_found_for_the_inspection: {
    message: ValidationMessages.InspectionAttachmentsNotFound,
    type: 'warn'
  },
  inspection_item_not_found: {
    message: ValidationMessages.InspectionItemNotFound,
    type: 'error'
  },
  no_attachments_found_for_the_inspection_item: {
    message: ValidationMessages.InspectionItemAttachmentsNotFound,
    type: 'warn'
  },
  lop_item_not_found: {
    message: ValidationMessages.LopItemNotFound,
    type: 'error'
  },
  no_attachments_found_for_the_lop_item: {
    message: ValidationMessages.LopItemAttachmentsNotFound,
    type: 'warn'
  }
};
